import { z } from 'zod';
import { FieldDefinitionSchema } from './settings-field.schema';

/**
 * Settings Section schema.
 */
export const SectionDefinitionSchema = z.object({
  id: z.string(),
  title: z.string().min(1, 'Title is required'),
  order: z.number().int().min(0),
  fields: z.array(FieldDefinitionSchema),
});

export type SectionDefinition = z.infer<typeof SectionDefinitionSchema>;
